import Image from "@tiptap/extension-image";
import { Table, TableCell, TableHeader, TableRow } from "@tiptap/extension-table";
import StarterKit from "@tiptap/starter-kit";

/**
 * The OpsHub document schema: Word-like basics + tables + images + links.
 *
 * LOCKSTEP: must match the server's render set
 * (server/src/services/content/render.ts) — a node the server doesn't know is
 * dropped from the published render.
 */
export const EXTENSIONS = [
  StarterKit.configure({
    heading: { levels: [2, 3] }, // page title is the H1; body structure is H2/H3
    link: { openOnClick: false },
  }),
  Table.configure({ resizable: false }),
  TableRow,
  TableHeader,
  TableCell,
  Image,
];
